module.exports = __webpack_public_path__ + "img/skitmelogo.3ae73f46.gif";